import { getCookieSync } from "@/lib/cookies";
import {
  defaultLanguage,
  supportedLanguages,
  type SupportedLanguage,
} from "@/lib/shared";

export const NEXT_LOCALE_COOKIE = "NEXT_LOCALE";

/**
 * Resolve UI language for the current screen.
 *
 * 1. `locale` from the route (`useParams().locale`) when present.
 * 2. First segment of `location.pathname` (SPA: nested routes may omit parent
 *    `:locale` in `useParams`, which previously forced cookie/default `ar`).
 * 3. `NEXT_LOCALE` cookie (manual preference when path has no locale).
 * 4. Site default.
 */
export function resolveLocale(localeParam: string | undefined): SupportedLanguage {
  if (localeParam && supportedLanguages.includes(localeParam as SupportedLanguage)) {
    return localeParam as SupportedLanguage;
  }
  if (typeof document !== "undefined") {
    const fromPath = window.location.pathname.split("/").filter(Boolean)[0];
    if (fromPath && supportedLanguages.includes(fromPath as SupportedLanguage)) {
      return fromPath as SupportedLanguage;
    }
    const c = getCookieSync(NEXT_LOCALE_COOKIE);
    if (c && supportedLanguages.includes(c as SupportedLanguage)) {
      return c as SupportedLanguage;
    }
  }
  return defaultLanguage;
}
